export default {
  pageTitle: '关于我们',
  heroSlogan: '专注跨境全链路服务，整合法律、金融与商务，护航企业出海',
  aboutUsTitle: '关于我们',
  paragraph1: 'LEVIY 利未涉外于2005年在杭州成立，并创建杭州总部，目前在香港、深圳等一线城市设有分公司，业务涉及全球50多个国家及地区。',
  paragraph2: '专注提供全球企业注册及秘书服务、涉外金融服务、国际税务筹划、海外架构搭建、海外身份规划、全球知识产权服务的一站式出海服务。',
  paragraph3: '历经20余年出海服务经验沉淀，成长为一站式出海服务与解决方案领导者，累积服务超100+企业，成就行业好口碑。',
  paragraph4: 'LEVIY 利未涉外已成功搭建广泛的全球法律服务网络，通过各国律师为客户提供与客户商业和个人需求相关的各国民事、商事和刑事法律服务。',
  stat1Label: '成立于',
  stat2Label: '覆盖国家',
  stat3Label: '服务企业',
  stat4Label: '行业经验',
  milestoneTitle: '发展历程',
  milestoneSubtitle: '见证我们的成长与发展',
  milestone1: '公司于杭州成立',
  milestone2: '业务拓展至全球20+国家',
  milestone3: '香港、深圳分公司成立',
  milestone4: '服务网络覆盖50+国家和地区',
  milestone5: '服务企业超过100+',
  valuesTitle: '核心价值观',
  valuesSubtitle: '我们的服务理念',
  value1Title: '专业',
  value1Desc: '20余年行业经验，专注跨境服务领域',
  value2Title: '诚信',
  value2Desc: '以诚信为本，为客户提供可靠的服务',
  value3Title: '创新',
  value3Desc: '不断创新服务模式，提升客户体验',
  value4Title: '全球化',
  value4Desc: '覆盖50+国家和地区的服务网络',
  officesTitle: '办公地点',
  officesSubtitle: '我们遍布全球的办公网络',
  office1City: '杭州总部',
  office1Address: '浙江省杭州市拱墅区中山北路 611 号地铁商务大厦11楼1101 室',
  office2City: '深圳分公司',
  office2Address: '广东省深圳市福田区福华一路1号大中华国际交易广场西区31楼3107',
  office3City: '香港分公司',
  office3Address: '香港九龙旺角通菜街1A-1L威达商业中心15楼08室',
  ctaTitle: '开启你的全球化之旅',
  ctaDesc: '选择LEVIY 利未涉外，选择专业、可靠的跨境服务伙伴',
  ctaButton: '邮件咨询',
}
